import React from "react";
import style from "./index.module.scss";
import { Button, Icon } from "antd";
import { freshNumberCode } from "service/signIn";
import { useAsyncFn, useInterval } from "react-use";
import usePromiseCallback from "../../../../../../../utils/usePromiseCallback";

interface NumPadProps {
    signInId: number;
    code: string;
    refreshTime: number;
}

export default function NumPad({ signInId, code, refreshTime }: NumPadProps) {
    const [refreshStatus, callRefresh] = useAsyncFn(
        () => freshNumberCode(signInId),
        [signInId]
    );

    const onRefreshClick = usePromiseCallback(async function () {
        await callRefresh();
    });

    // 每隔若干秒刷新下状态
    useInterval(onRefreshClick, (refreshTime || 10) * 1000);

    return (
        <div className={style.root}>
            <div className={style.num}>{refreshStatus?.value || code}</div>

            <div className={style.buttons}>
                <Button className={style.button} onClick={onRefreshClick}>
                    <Icon type="sync" /> 更换数字码
                </Button>
            </div>
        </div>
    );
}
